import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import config from '../../../../../config';
import { toast } from 'react-toastify';

function BankEditModal({ show, onHide, buyerId, bank_details = {}, onUpdated }) {
    const [bank, setBank] = useState(bank_details);
    const [saving, setSaving] = useState(false);

    const accountTypeOptions = [
        { value: 'savings', label: 'Savings' },
        { value: 'current', label: 'Current' },
        { value: 'cash_credit', label: 'Cash Credit' },
        { value: 'overdraft', label: 'Overdraft' },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBank((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (selectedOption) => {
        setBank((prev) => ({
            ...prev,
            account_type: selectedOption?.value || '',
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);

        try {
            await axios.put(`${config.API_BASE_URL}/buyers/${buyerId}`, {
                bank_details: bank,
            });

            toast.success('Bank details updated successfully');
            onUpdated();
            onHide();
        } catch (err) {
            console.error('Failed to update bank details:', err);
            toast.error('Failed to update bank details');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Edit Bank Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Account Holder Name</Form.Label>
                                <Form.Control
                                    name="account_name"
                                    value={bank.account_name || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Account Number</Form.Label>
                                <Form.Control
                                    name="account_number"
                                    value={bank.account_number || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Bank Name</Form.Label>
                                <Form.Control
                                    name="bank"
                                    value={bank.bank || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>Branch</Form.Label>
                                <Form.Control
                                    name="branch"
                                    value={bank.branch || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2">
                                <Form.Label>IFSC Code</Form.Label>
                                <Form.Control
                                    name="ifsc"
                                    value={bank.ifsc || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} xl={4}>
                            <Form.Group className="mb-2 fs-9">
                                <Form.Label>Account Type</Form.Label>
                                <Select
                                    name="account_type"
                                    value={accountTypeOptions.find(opt => opt.value === bank.account_type)}
                                    onChange={handleSelectChange}
                                    options={accountTypeOptions}
                                    placeholder="-- Select Account Type --"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="mt-4">
                        <Button type="submit" variant="primary" disabled={saving}>
                            {saving ? 'Saving...' : 'Save'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default BankEditModal;
